import Vue from 'vue';
import Router from 'vue-router';
import Welcome from './views/Home.vue';
import Selection from './views/Selection.vue';
import BusinessInfo from './views/bussiness/BusinessInfo.vue';
import BusinessNote from './views/bussiness/BusinessNote.vue';
import BusinessContactInfo from './views/bussiness/BusinessContact.vue';
import BusinessAddress from './views/bussiness/BusinessAddress.vue';
import BusinessLoyalty from './views/bussiness/BussinessLoyaltyCard.vue';
import BusinessThankYou from './views/bussiness/BusinessThankYou.vue';
import IndividualInfo from './views/individual/IndividualInfo.vue';
import IndividualAddress from './views/individual/IndividualAddress.vue';
import IndividualLoyaltyCard from './views/individual/IndividualLoyaltyCard.vue';
import IndividualThankYou from './views/individual/IndividualThankYou.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'welcome',
			component: Welcome
		},
		{
			path: '/selection',
			name: 'selection',
			component: Selection
		},
		{
			path: '/businessInfo',
			name: 'businessInfo',
			component: BusinessInfo
		},
		{
			path: '/businessNote',
			name: 'businessNote',
			component: BusinessNote
		},
		{
			path: '/businessContactInfo',
			name: 'businessContactInfo',
			component: BusinessContactInfo
		},
		{
			path: '/businessaddress',
			name: 'businessaddress',
			component: BusinessAddress
		},
		{
			path: '/businessloyalty',
			name: 'businessloyalty',
			component: BusinessLoyalty
		},
		{
			path: '/businessthanks',
			name: 'businessthanks',
			component: BusinessThankYou
		},
		{
			path: '/info',
			name: 'individualinfo',
			component: IndividualInfo
		},
		{
			path: '/address',
			name: 'individualaddress',
			component: IndividualAddress
		},
		{
			path: '/loyaltycard',
			name: 'individualloyaltycard',
			component: IndividualLoyaltyCard
		},
		{
			path: '/thankyou',
			name: 'individualthankyou',
			component: IndividualThankYou
		}
	]
});
